import {
	faDatabase,
	faFolder,
	faFolderOpen,
	faLayerGroup,
	faProjectDiagram,
	faRetweet,
	faTable,
	faTasks,
	faWifi,
	faWindowMaximize,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { StructureObjectDto as StructureObjectDtoOld } from '@/endpoints/models'
import { StructureObjectDto } from '@/rtkApi/mddApiSliceGenerated'
import entityColors from '@/styles/entityColors'

const typeToIcon = {
	[StructureObjectDtoOld.TypeEnum.ROOT]: faFolder,
	[StructureObjectDtoOld.TypeEnum.SYSTEM]: faDatabase,
	[StructureObjectDtoOld.TypeEnum.FOLDER]: faFolder,
	[StructureObjectDtoOld.TypeEnum.FOLDER_WORKFLOW]: faFolder,
	[StructureObjectDtoOld.TypeEnum.TABLE]: faTable,
	[StructureObjectDtoOld.TypeEnum.TABLE_COLUMN]: faTable,
	[StructureObjectDtoOld.TypeEnum.VIEW]: faWindowMaximize,
	[StructureObjectDtoOld.TypeEnum.MAPPING]: faRetweet,
	[StructureObjectDtoOld.TypeEnum.MAPPING_DEFAULT]: faRetweet,
	[StructureObjectDtoOld.TypeEnum.WORKFLOW]: faProjectDiagram,
	[StructureObjectDtoOld.TypeEnum.API_NODE]: faWifi,
	[StructureObjectDtoOld.TypeEnum.MAPPING_READ]: faRetweet,
	[StructureObjectDtoOld.TypeEnum.API_COLLECTION]: faLayerGroup,
	[StructureObjectDtoOld.TypeEnum.QUEUE]: faTasks,
	[StructureObjectDtoOld.TypeEnum.MAPPING_WRITE]: faRetweet,
	[StructureObjectDtoOld.TypeEnum.CONSTANT_DOMAIN]: faRetweet,
	['DIAGRAM']: faProjectDiagram,
}

const typeToExpandedIcon: Partial<Record<string, typeof faFolderOpen>> = {
	FOLDER: faFolderOpen,
	FOLDER_WORKFLOW: faFolderOpen,
}

export const EntityTypeIcon = ({
	type,
	expanded,
}: {
	expanded?: boolean
	type: StructureObjectDto['type']
}) => {
	if (!type) return null

	return (
		<FontAwesomeIcon
			icon={(expanded && typeToExpandedIcon[type]) || typeToIcon[type]}
			color={entityColors[type]}
			fixedWidth
		/>
	)
}
